require('./../fb_sdk.js');
require('../../../../legacy/node_modules/parsleyjs/dist/parsley.js');
require('../../../../legacy/node_modules/parsleyjs/dist/i18n/pt-br.js');

window.fbLogin = function() {
    FB.login(function (response) {
        if (response.status === 'connected') {
            let l = Ladda.create( document.querySelector('.btn-facebook') );
            l.start();
            FB.api('/me?fields=first_name,last_name,email', function(response) {
                const user = response;
                axios.post('/auth/social-login', {
                    uid: user.id,
                    provider: 'facebook',
                    email: user.email,
                    first_name: user.first_name,
                    last_name: user.last_name
                }).then(function (res) {
                    if (res.data.response) {
                        if (res.data.new_user) {
                            window.dataLayer.push({
                                event: 'new_user',
                                event_category: 'new_user_registered',
                                event_label: 'new_user_facebook',
                            });
                        }
                        setTimeout(function() {
                            location.reload();
                        }, 500);
                    } else {
                        $('#alert-fblogin').show();
                    }
                }).catch(function (err) {
                    if (err.response) {
                        if (err.response.status === 401) {
                            if (err.response.data.message === 'banned_account') {
                                window.App.error('Esta conta foi banida. Fale conosco pelo email contato@webquarto.com.br!');
                            }
                        }
                    } else {
                        window.App.error('Ocorreu um erro enquanto tentávamos conectar sua conta com o Facebook. Por favor, atualize esta página e tente novamente!');
                        Sentry.captureException(err);
                    }
                }).finally(function () {
                    l.stop();
                });
            });
        }
    });
}
